<template>
  <div class="pdf-zoom">
    <v-btn icon large @click.prevent.stop="zoomIn">
      <v-icon small>zoom_in</v-icon>
    </v-btn>
    <v-btn icon large @click.prevent.stop="zoomOut">
      <v-icon small>zoom_out</v-icon>
    </v-btn>
    <v-btn icon large @click.prevent.stop="fitWidth">
      <v-icon small>zoom_out_map</v-icon>
    </v-btn>
    <v-btn icon large @click.prevent.stop="fitAuto">
      <v-icon small>aspect_ratio</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'PDFZoom',

  components: {},

  props: {
    scale: {
      type: Number
    },
    increment: {
      type: Number,
      default: 0.25
    }
  },

  computed: {
    isDisabled() {
      return !this.scale;
    }
  },

  methods: {
    zoomIn() {
      this.updateScale(this.scale + this.increment);
    },

    zoomOut() {
      if (this.scale <= this.increment) return;
      this.updateScale(this.scale - this.increment);
    },

    updateScale(scale) {
      this.$emit('change', { scale });
    },

    fitWidth() {
      this.$emit('fit', 'width');
    },

    fitAuto() {
      this.$emit('fit', 'auto');
    }
  }
};
</script>

<style>
.pdf-zoom a {
  float: left;
  cursor: pointer;
  display: block;
  border: 1px #333 solid;
  background: white;
  color: #333;
  font-weight: bold;
  line-height: 1.5em;
  width: 1.5em;
  height: 1.5em;
  font-size: 1.5em;
}
</style>
